import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=39d485d0&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d485d0')) {
      api.createRecord('39d485d0', component.options)
    } else {
      api.reload('39d485d0', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=39d485d0&", function () {
      api.rerender('39d485d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/buttons/Button.vue"
export default component.exports